// extracted by mini-css-extract-plugin
export default {"selectWrapper":"error_selectWrapper__GGUqM","iconStyle":"error_iconStyle__WMPBW","staticColorLight":"error_staticColorLight__uPxj8"};